import { Fetch } from '../helpers/fetchWrapper';

const workflowService = {
  _url: process.env.REACT_APP_AUTH_API_URL,

  async getWorkflows() {
    return await Fetch.get(`${this._url}/workflow/list`);
  },
  async createWorkflowChat(payload) {
    return await Fetch.post(`${this._url}/workflow/run`, payload, false, true);
  },
  async getWorkflowDetail(workflow_id) {
    return await Fetch.get(`${this._url}/workflow/details?workflow_id=${workflow_id}`);
  },
  async createWorkflow(payload) {
    return Fetch.post(`${this._url}/workflow/create`, payload);
  },
  async updateWorkflow(payload) {
    return await Fetch.put(`${this._url}/workflow/update`, payload);
  },
  async deleteWorkflow(workflow_id) {
    return await Fetch.delete(`${this._url}/workflow/delete?workflow_id=${workflow_id}`);
  },
};

export default workflowService;
